var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uk-container uk-background-primary uk-light",attrs:{"data-app":""}},[_c('bac-logged-in-header'),_c('router-link',{staticClass:"uk-icon",attrs:{"to":"/admin","uk-tooltip":"pos:bottom-right","uk-icon":"icon:reply; ratio:2;"}}),_c('h1',{staticClass:"uk-h1"},[_vm._v("Teamarea Statistiken")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }